import { getDOMNodeInNavigatorWithDataId } from '@ardoq/component-hierarchies';
import { ArdoqId } from '@ardoq/api-types';
import * as canvasHitTestRegistry from 'tabview/canvasRendering/canvasHitTestRegistry';
import { CANVAS_HIT_TEST_ATTRIBUTE } from 'tabview/canvasRendering/canvasHitTestRegistry';

/** Where the pointer is and the element it is over. */
export type PointerSample = Pick<MouseEvent, 'target' | 'clientX' | 'clientY'>;

const COMPONENT_ELEMENT_SELECTOR =
  '.component-item[data-id], [data-component-id]';

/** The element standing for a component, from anything inside it. */
export const getComponentElement = (target: Element | null) =>
  target?.closest(COMPONENT_ELEMENT_SELECTOR) ?? null;

export const getTarget = ({ target }: Pick<Event, 'target'>) =>
  target instanceof Element ? getComponentElement(target) : null;
export const getTargetId = (target: Element | null | undefined) =>
  target &&
  (target.getAttribute('data-component-id') ||
    target.getAttribute('data-id') ||
    getDOMNodeInNavigatorWithDataId(target));

const getCanvasComponentId = (event: PointerSample): ArdoqId | null => {
  if (!(event.target instanceof Element)) return null;
  const canvas = event.target.closest(`[${CANVAS_HIT_TEST_ATTRIBUTE}]`);
  const viewInstanceId = canvas?.getAttribute(CANVAS_HIT_TEST_ATTRIBUTE);
  if (!viewInstanceId) return null;
  return canvasHitTestRegistry.get(viewInstanceId)?.hitTest(event) ?? null;
};

/**
 * The component under the pointer, across every surface: DOM and SVG nodes
 * carry the id as an attribute, canvas-rendered views answer by coordinate
 * through the hit test registry.
 */
export const resolveComponentIdAtPointer = (
  event: PointerSample
): ArdoqId | null =>
  getTargetId(getTarget(event)) || getCanvasComponentId(event);
